import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { ErrorFilledIcon, WarningTriangleIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { getStatusNoteStyles, statusNoteIconStyles } from '../../SendStep.styles';
import { SendStepTestIds } from '../../SendStep.testIds';

const SendStatusNote = ({ isError, message }) => {
  const Icon = isError ? ErrorFilledIcon : WarningTriangleIcon;

  return (
    <Box data-testid={SendStepTestIds.STATUS_NOTE} sx={getStatusNoteStyles(isError)}>
      <Box sx={statusNoteIconStyles}>
        <Icon size={IconSize[18]} />
      </Box>
      <Typography variant="regular12">{message}</Typography>
    </Box>
  );
};

SendStatusNote.propTypes = {
  message: PropTypes.string.isRequired,
  isError: PropTypes.bool,
};

export default memo(SendStatusNote);
